export const skeleton = [
  {
    "title": "",
    "url": "domestic/negligence/2022_01 HA ADDENDUM CA-2022-000051-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 HA ADDENDUM CA-2022-000051-2.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 HA ADDENDUM CA-2022-000051-3.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 HA ADDENDUM CA-2022-000051-4.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 HA ADDENDUM CA-2022-000051-5.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 PFE ADDENDUM CA-2022-000051-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 PFE ADDENDUM CA-2022-000051-2.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 PFE ADDENDUM CA-2022-000051-3.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 PFE TLATA ADDENDUM CA-2022-000051-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_01 PFE TLATA ADDENDUM CA-2022-000051-2.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-01.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-02.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-03.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-04.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-05.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-06.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-07.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-08.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-09.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-10.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-11.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-12.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-13.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-14.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-15.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-16.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-17.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-18.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-19.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-20.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-21.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-22.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-23.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-24.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-25.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-26.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-27.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-28.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-29.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-30.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-31.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04 SKELETON ARGUMENT CA-2022-000051-32.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04_27 CA-2022-000051 BUNDLE INDEX-1.jpg"
  },
  {
    "title": "",
    "url": "domestic/negligence/2022_04_27 CA-2022-000051 BUNDLE INDEX-2.jpg"
  }
];
